import React, { createContext, useState, useContext, useEffect, useCallback } from 'react'

const LoadingContext = createContext({
  isLoading: false,
  setLoading: () => {}
})

// Referencia a nivel de módulo para que el fetch interceptor
// pueda cambiar el estado de loading sin estar dentro del árbol de React
/** @type {(visible: boolean) => void} */
let _setLoadingRef = (_visible) => {}

export const getLoadingSetter = () => _setLoadingRef

export const LoadingProvider = ({ children }) => {
  const [isLoading, setIsLoading] = useState(false)
  const requestCountRef = React.useRef(0)

  const setLoading = useCallback((visible) => {
    if (visible) {
      requestCountRef.current += 1
      setIsLoading(true)
    } else {
      requestCountRef.current = Math.max(0, requestCountRef.current - 1)
      if (requestCountRef.current === 0) {
        setIsLoading(false)
      }
    }
  }, [])

  useEffect(() => {
    _setLoadingRef = setLoading
    return () => {
      _setLoadingRef = () => {}
    }
  }, [setLoading])

  return <LoadingContext.Provider value={{ isLoading, setLoading }}>{children}</LoadingContext.Provider>
}

export const useLoading = () => useContext(LoadingContext)

export default LoadingContext
